import * as React from "react";
import { helpers } from "@elrondnetwork/dapp-utils";
import { LeaderboardEntryType } from "context/state";
import extractValues from "./extractValues";
import RowCell from "./RowCell";

const trimHash = (hash: string, keep = 10) => {
  const start = hash.substring(0, keep);
  const end = hash.substring(hash.length - keep);
  return `${start}...${end}`;
};

const LeaderRow = (props: LeaderboardEntryType & { rank: number }) => {
  const {
    rank,
    address,
    netWorth,
    balance: egldBalance,
    balanceUSD,
    nonce,
  } = props;

  const { BUSD, MEX, EGLDBUSD, LKMEX, EGLDMEX, MEXFARM, EGLDMEXF, EGLDBUSDF } =
    extractValues(props);

  return (
    <tr>
      <td className="text-right">{rank}</td>
      <td>{trimHash(address)}</td>
      <td className="score text-right">
        $
        {helpers.usdValue({
          amount: String(netWorth),
          usd: 1,
        })}
      </td>
      <RowCell balance={MEXFARM.balance} valueUSD={MEXFARM.valueUSD} />
      <RowCell balance={EGLDMEXF.balance} valueUSD={EGLDMEXF.valueUSD} />
      <RowCell balance={EGLDBUSDF.balance} valueUSD={EGLDBUSDF.valueUSD} />

      <RowCell balance={egldBalance} valueUSD={balanceUSD} />
      <RowCell
        balance={MEX?.balance ?? "0"}
        valueUSD={MEX?.valueUSD ?? "0.00"}
      />
      <RowCell balance={LKMEX.balance} valueUSD={LKMEX.valueUSD} />
      <RowCell
        balance={BUSD?.balance ?? "0"}
        valueUSD={BUSD?.valueUSD ?? "0.00"}
      />
      <RowCell
        balance={EGLDBUSD?.balance ?? "0"}
        valueUSD={EGLDBUSD?.valueUSD ?? "0.00"}
      />
      <RowCell
        balance={EGLDMEX?.balance ?? "0"}
        valueUSD={EGLDMEX?.valueUSD ?? "0.00"}
      />
      <td className="score text-right">{nonce.toLocaleString("en")}</td>
    </tr>
  );
};
export default LeaderRow;
